/* RSC Health — keyless IP → approximate location (Phase 2). Powers on-load
   auto-location of nearby test centers with no permission prompt. Chain:
   ipwho.is → geojs.io → null. Session-cached so it fires once per visit.
   Pure parsers are exported for Node tests; ipLocate runs in the browser.
   Only the visitor's own IP leaves the page (to the geo service). No PHI. */
(function (root) {
  'use strict';

  function num(v) { var n = parseFloat(v); return isFinite(n) ? n : null; }

  function parseIpwho(j) {
    if (!j || j.success === false) return null;
    var lat = num(j.latitude), lng = num(j.longitude);
    if (lat === null || lng === null) return null;
    return { lat: lat, lng: lng, city: j.city || '', region: j.region_code || '' };
  }

  function parseGeojs(j) {
    if (!j) return null;
    var lat = num(j.latitude), lng = num(j.longitude);
    if (lat === null || lng === null) return null;
    return { lat: lat, lng: lng, city: j.city || '', region: j.region || '' };
  }

  var CACHE_KEY = 'rsc_ip_geo';

  function readCache() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      return raw == null ? undefined : JSON.parse(raw);   // undefined = not tried; else geo|null
    } catch (e) { return undefined; }
  }
  function writeCache(geo) {
    try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(geo)); } catch (e) {}
  }

  function fetchJson(url, cb) {
    // Two-arg then(): the error handler catches ONLY fetch/JSON rejections, never
    // an exception thrown by cb — so cb fires exactly once and consumer errors surface.
    fetch(url).then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { cb(j); }, function () { cb(null); });
  }

  // Approximate {lat,lng,city,region} from the visitor's IP, or null. cb once.
  function ipLocate(cb) {
    var cached = readCache();
    if (cached !== undefined) { cb(cached); return; }
    fetchJson('https://ipwho.is/', function (j1) {
      var g = parseIpwho(j1);
      if (g) { writeCache(g); cb(g); return; }
      fetchJson('https://get.geojs.io/v1/ip/geo.json', function (j2) {
        var g2 = parseGeojs(j2) || null;
        writeCache(g2);
        cb(g2);
      });
    });
  }

  var api = { ipLocate: ipLocate, parseIpwho: parseIpwho, parseGeojs: parseGeojs };
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; }
  else { root.RSCIpGeo = api; }
})(typeof window !== 'undefined' ? window : this);
